import {
  Box,
  Button,
  Typography,
  Dialog,
  Grid,
  Container,
  CssBaseline,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingButtonText } from "../../common";
import { handleProcurementMarkItemInactive } from "./functions";

export function SampleRequestApprovalProcurementMarkItemInactiveModal(props) {
  const history = useNavigate();
  // State to store loading state
  const [isSubmitting, setIsSubmitting] = useState(false);
  // State to store any validation errors
  const [errors, setErrors] = useState();

  // Effect to initialize form values when the modal opens based on props.data
  useEffect(() => {
    setIsSubmitting(false);
  }, [props.data]);

  // Function to close the modal and reset form states
  const handleClose = () => {
    props.setOpen(false);
    setIsSubmitting(false);
  };

  // Function to handle form submission for deleting an item
  async function handleMarkInactive() {
    await handleProcurementMarkItemInactive(
      setErrors,
      setIsSubmitting,
      props,
      history,
      handleClose
    );
  }

  errors && console.log({ errors });

  return (
    <Dialog open={props.open} onClose={handleClose} {...DialogProps}>
      <Box
        sx={{
          display: props.display,
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Container {...ContainerProps}>
          <Typography {...TypographyProps}>Mark Inactive</Typography>
          <CssBaseline />
          <Box {...FormBoxProps}>
            <p>
              Are you sure you want to mark this item as <b>Inactive</b>?<br />
              <span style={{ color: "red" }}>
                <b> This action is irreversible.</b>
              </span>
            </p>
            <Grid {...ButtonGridProps}>
              <Grid item>
                <Button onClick={handleMarkInactive} {...DeleteButtonProps}>
                  <LoadingButtonText
                    loading={isSubmitting}
                    text="Mark Inactive"
                  />
                </Button>
              </Grid>
              <Grid item>
                <Button onClick={handleClose} {...CancelButtonProps}>
                  <LoadingButtonText loading={isSubmitting} text="Cancel" />
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </Dialog>
  );
}

const DialogProps = {
  style: {
    height: "90%",
  },
  PaperProps: { sx: { borderRadius: "10px" } },
};

const TypographyProps = {
  component: "h1",
  variant: "h5",
};

const ContainerProps = {
  component: "main",
  maxWidth: "sm",
  sx: {
    marginTop: 4,
    flexDirection: "column",
    alignItems: "center",
  },
};

const FormBoxProps = {
  component: "form",
  noValidate: true,
  sx: {
    mt: 5,
  },
};

const ButtonGridProps = {
  container: true,
  spacing: 2,
  sx: {
    mt: 1,
    flexDirection: "row",
    justifyContent: "center",
  },
};

const DeleteButtonProps = {
  variant: "contained",
  color: "error",
  sx: {
    mt: 3,
    mb: 3,
    width: "150px",
  },
};

const CancelButtonProps = {
  variant: "contained",
  sx: {
    mt: 3,
    mb: 3,
    width: "150px",
  },
};
